import { render, staticRenderFns } from "./AppEndPoint.vue?vue&type=template&id=6b5be7dc&"
import script from "./AppEndPoint.vue?vue&type=script&lang=js&"
export * from "./AppEndPoint.vue?vue&type=script&lang=js&"
import style0 from "./AppEndPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports